import PageBody from "../components/ui/layout/PageBody";
import {Link} from "react-router-dom";

export default function FourOhFour() {
    return (
        <PageBody>
            <div className="mx-auto">
                <div className="flex flex-col items-center">
                    <h1 className="text-7xl font-bold mb-8">404</h1>
                    <div className="flex space-x-4 items-end">
                        <p>Page not found!</p>
                        <Link className="text-blue-600 visited:text-purple-600 underline" to="/">Return Home</Link>
                    </div>
                </div>
            </div>
        </PageBody>
    );
}
